import {
  currencyString,
  formatDate,
  isDefined,
  isFullPayoffPayment,
  isPaymentBeforeDueDate,
  presentableProductType,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessageEarlyAmountDueAutoPayAndNonAutopay: UseMessageT = (props) => {
  const {
    dueAmount,
    dueDate,
    fullPayoffAmount,
    isAutopay,
    isAutopayPending,
    loanStatus,
    isFullPayoffDisabled,
    isNextMinimumPaymentDisabled,
    originalDueAmount,
    paymentAmount,
    paymentDate,
    productType,
    scheduledAmount,
  } = props;

  if (!isDefined(dueAmount)
    || !isDefined(dueDate)
    || !isDefined(isFullPayoffDisabled)
    || !isDefined(isNextMinimumPaymentDisabled)
    || !isDefined(originalDueAmount)
    || !isDefined(paymentAmount)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
    || !isDefined(fullPayoffAmount)
  ) { return undefined; }

  const isCurrent = loanStatus === 'current';

  const fullPayoffProps = {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  };

  const hasRemainingBalance = dueAmount < originalDueAmount;

  // NCFE-10082 (D-1)
  if (((isAutopay && !isAutopayPending) || !isAutopay)
    && isCurrent
    && isPaymentBeforeDueDate(paymentDate, dueDate)
    && dueAmount > 0
    && dueAmount === scheduledAmount
    && paymentAmount >= dueAmount
    && !isFullPayoffPayment(fullPayoffProps)
    && !isNextMinimumPaymentDisabled
  ) {
    return (
      <p>
        This payment will{' '}
        <span className="fw-bold">
          satisfy your {presentableProductType(productType)}{' '}
        </span>
        of {currencyString(dueAmount)}{' '}
        {hasRemainingBalance && 'remaining'}{' '}
        due on {formatDate(dueDate)}.
      </p>
    );
  }

  return undefined;
};
